module.exports = __webpack_public_path__ + "img/1.58d8d406.svg";